import { type UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { GetUserProfileResponse } from 'generated/openapi';

import { getMyProfileKey, getMyProfileOptions } from './getMyProfile.options';

export interface UseGetMyProfileProps<T = GetUserProfileResponse> {
  options?: Omit<
    UseQueryOptions<GetUserProfileResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetMyProfile<T = GetUserProfileResponse>(
  props: UseGetMyProfileProps<T>,
) {
  const { options } = props;

  return useSuspenseQuery({
    ...getMyProfileOptions<T>(),
    ...options,
  });
}

useGetMyProfile.getQueryKey = getMyProfileKey;
